import { BroadcastEvent } from '@y42/browser/broadcast-event';

export class AuthChangeBroadcastEvent extends BroadcastEvent<{ token?: string }> {
  type = 'auth-change';
}
